import { createSelector } from 'reselect';

export const selectZonesSlice = state => state.zones;

export const selectZones = createSelector(
  selectZonesSlice,
  slice => slice.zones
);
export const zonesLoaded = createSelector(
  selectZonesSlice,
  slice => slice.zonesLoaded
);
export const selectActiveZone = createSelector(
  selectZonesSlice,
  slice => slice.activeZone
);
export const zoneCreating = createSelector(
  selectZonesSlice,
  slice => slice.isCreating
);
export const zonesMeta = createSelector(
  selectZonesSlice,
  slice => slice.meta
);
export const zonesFilters = createSelector(
  selectZonesSlice,
  slice => slice.filters
);
